export const AD_CREDIT = {
  MAIN: "/ad-credit",
  ADD: "/user-ad-credit/add",
  DEDUCT: "/user-ad-credit/deduct",
  GET_USER_AD_CREDIT_BY_ADMIN: "/ad-credit/all",
  GET_USER_AD_CREDIT_HISTORY_BY_ADMIN: "/user-ad-credit/history",
  GET_USER_AD_CREDIT_HISTORY: "/user-ad-credit/history/me",
  GET_USER_AD_CREDIT_COLLAPSE_HISTORY_BY_ADMIN:
    "/user-ad-credit/collapse-history",
  GET_USER_AD_CREDIT_COLLAPSE_HISTORY: "/user-ad-credit/collapse-history/me",
  GET_USER_AD_CREDIT: "/user-ad-credit/me",
  CREATE_ODER: "/ad-credit/order",
  AD_CREDIT_PRICE_PER_USER: "/ad-credit/all",
  UPDATE_USER_CREDIT: "/user-ad-credit/admin/update",
  UPDATE_USER_CREDIT_CATEGORY: "/user-ad-credit/update-category",
  REVERT_TRANSACTION: "/user-ad-credit/revert-transaction",
  REVERT_SPECIFIC_TRANSACTION: "/user-ad-credit/revert-specific-transaction",
};
